interface ToggleSwitchProps {
  checked: boolean;
  onChange: (val: boolean) => void;
  ariaLabel?: string;
}

const ToggleSwitch = ({ checked, onChange, ariaLabel }: ToggleSwitchProps) => (
  <button
    type='button'
    role='switch'
    aria-checked={checked}
    aria-label={ariaLabel}
    onClick={() => onChange(!checked)}
    className={`relative inline-flex h-8 w-14 items-center rounded-full cursor-pointer transition-colors duration-200 focus:outline-none disabled:cursor-not-allowed disabled:opacity-50 disabled:grayscale ${
      checked ? 'bg-orange-500' : 'bg-gray-500/60'
    }`}
  >
    <span className='sr-only'>{ariaLabel}</span>
    <span
      className={`absolute left-1 top-1 flex h-6 w-6 items-center justify-center rounded-full bg-white text-sm font-bold transition-transform duration-200 ${
        checked ? 'translate-x-6' : ''
      }`}
    >
      {checked ? '✓' : '✕'}
    </span>
  </button>
);

export default ToggleSwitch;
